import React from 'react';
import classnames from 'classnames';
import ReactHtmlParser from 'react-html-parser';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { withLocalize, Translate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Circles } from '../../common/loadingComponent';
import { layoutActions } from '../../../store/layoutStore';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { apiGet, getHostApi } from '../../../store/apiWrapper';
import Paging from '../../common/pagingComponent';
import Message from '../../common/message';
import NoDataComponent from '../../common/noDataComponent';
import RefreshComponent from '../../layoutItems/refreshComponent';

const STATUS = {
    unprocessed: "Unprocessed",
    processed: "Processed",
    read: "Read",
    error: "Error",
    obligation: "MonetaryObligation",
    obliAdded: "MonetaryObligationAdded",
    delayed: "Delayed"
};

const MIN_PAGESIZE = 50;

class PropertyCzSearchRequests extends React.Component {
    state = {
        pageSize: MIN_PAGESIZE,
        index: 1,
        data: null,
        totalCount: null,
        autoRefresh: false,
        isLoading: false,
        isRefreshing: false,
        manualOverride: false,
        error: null
    };

    timer = null;

    render() {
        if (this.state.isLoading)
            return <Circles />;
        else
            if (!isNullOrUndefined(this.state.data) && this.state.data.length > 0)
                return this.renderTable();
            else if (this.state.error)
                return <div className="error-container error-container-wide" style={{ marginTop: "0.75em" }}>
                    <Message type={"error"} message={this.props.translate((((this.state.error.data || {}).error || {}).message) || "UnhappyUser.InternalServerError")} options={{ renderInnerHtml: true }} />
                </div>
            else
                return <NoDataComponent style={{ height: "100%" }} />
    }

    componentDidMount() {
        this.getData();
    }

    componentWillUnmount() {
        clearTimeout(this.timer);
    }

    renderTable() {
        return (
            <>
                <div style={{ display: "flex" }}>
                    {!isNullOrUndefined(this.state.data) && this.state.data.length > 0 && <RefreshComponent
                        style={{ margin: "1em 0", flex: "1 0 auto" }}
                        autoRefresh={this.state.autoRefresh}
                        onAutoRefresh={() => this.onAutoRefresh(!this.state.autoRefresh)}
                        onRefresh={() => this.getData()}
                    />}
                    <div style={{ margin: "auto", display: "flex" }}>
                        <Paging selectedPage={this.state.index}
                            totalPages={Math.ceil(this.state.totalCount / this.state.pageSize)}
                            setPage={this.onPageClick}
                            alwaysShow={Math.ceil(this.state.totalCount / MIN_PAGESIZE) > 1}
                        />
                        {Math.ceil(this.state.totalCount / MIN_PAGESIZE) > 1 && <>
                            <label style={{ fontSize: ".9em", margin: "auto", padding: "0em .7em" }}>
                                {ReactHtmlParser(this.props.translate('Search.PageSize'))}
                            </label>
                            <input type="number"
                                className="results-pagesize-input"
                                autoComplete="off"
                                onChange={(e) => this.onPageSizeChange(e.target.value)}
                                value={this.state.pageSize}
                                style={{ width: "5em", borderRadius: "1em", textAlign: "center" }}
                            />
                        </>}
                    </div>
                    {!isNullOrUndefined(this.state.data) && this.state.data.length > 0 && <RefreshComponent
                        style={{ visibility: "hidden", flex: "1 0 auto" }}
                        autoRefresh={this.state.autoRefresh}
                        onAutoRefresh={() => this.onAutoRefresh(!this.state.autoRefresh)}
                        onRefresh={() => this.getData()}
                    />}
                </div>
                <div className="search-progress searching" style={{ visibility: this.state.isRefreshing ? "visible" : "hidden" }} />
                <div className="card">
                    <div className="card-body card-body-fill">
                        {!this.state.isLoading && !isNullOrUndefined(this.state.data) && this.state.data.length > 0 && <div className="responsive-table">
                            <table className="table table-report-section table-marketing-list">
                                <thead>
                                    <tr>
                                        <th><Translate id="Search.Common.Request" /></th>
                                        <th><Translate id="Search.Cee.DateRequested" /></th>
                                        <th><Translate id="Search.Cee.Status" /></th>
                                        <th><Translate id="Search.Cee.DateProcessed" /></th>
                                        <th><Translate id="SearchResult.ResultsCount" /></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.data.map((req) => this.getRow(req))}
                                </tbody>
                            </table>
                        </div>}
                    </div>
                </div>
                <div className="paging-wrapper">
                    <Paging justify="center"
                        selectedPage={this.state.index}
                        totalPages={Math.ceil(this.state.totalCount / this.state.pageSize)}
                        setPage={this.onPageClick}
                        alwaysShow={Math.ceil(this.state.totalCount / MIN_PAGESIZE) > 1}
                    />
                </div>
            </>
        );
    }

    onPageSizeChange = (value) => {
        let parsed = parseInt(value);
        if (isNullOrUndefined(parsed) || isNaN(parsed) || parsed < MIN_PAGESIZE)
            parsed = MIN_PAGESIZE;
        this.setState({ pageSize: parsed }, () => { this.getData() })
    }

    onPageClick = (page) => {
        this.setState({ index: page }, () => { this.getData() })
    }

    onAutoRefresh = (value) => {
        this.setState({ autoRefresh: value, manualOverride: true });
        if (value)
            this.setTimer(5000);
    }

    getData = () => {
        // Previous request has not yet finished, try later
        if (this.state.isLoading === true || this.state.isRefreshing === true) {
            this.setTimer(1000);
            return;
        }

        if (isNullOrUndefined(this.state.data))
            this.setState({ isLoading: true });
        else
            this.setState({ isRefreshing: true });


        apiGet(`${getHostApi()}/api/cuzk/requests`, { pageSize: this.state.pageSize, index: this.state.index - 1 },
            (data) => this.success(data.data),
            (e) => this.onError(e),
            () => this.setState({ isLoading: false, isRefreshing: false })
        );
    }

    onError = (e) => {
        this.setState({ isLoading: false, isRefreshing: false, error: e });
        if (this.state.manualOverride && this.state.autoRefresh)
            this.setTimer(5000);
    }

    success = (data) => {
        this.setState({ isLoading: false, isRefreshing: false, error: null });
        //there are unprocessed data and user hasnt overriden the control or user has overriden and set to true
        let unprocessed = this.hasUnprocessed(data.resultList);
        if ((unprocessed && !this.state.manualOverride) || this.state.manualOverride && this.state.autoRefresh) {
            this.setState({ autoRefresh: true, data: data.resultList, totalCount: data.totalCount });
            this.setTimer(5000);
        }
        else
            this.setState({ autoRefresh: false, data: data.resultList, totalCount: data.totalCount });
    }

    setTimer = (ms) => {
        clearTimeout(this.timer);
        this.timer = setTimeout(this.getData, ms);
    }

    hasUnprocessed = (data) => {
        return data.filter(x => x.status === STATUS.unprocessed || x.status !== STATUS.delayed).length > 0
    }

    getRow = (req, isDetail = false, idx = 0) => {
        return (
            <React.Fragment key={req.id || idx * -1}>
                <tr className='colorize' onClick={() => this.getLink(req, true)} style={{ cursor: this.getLink(req, false) === true ? "pointer" : "" }}>
                    <td data-label={this.props.translate("Search.Common.Request")} style={{ paddingLeft: isDetail ? "2.5em" : "", fontWeight: isDetail ? "600" : "700" }} >
                        {(req.status === STATUS.unprocessed || !req.completed) ? <span>{req.displayName}</span> :
                            <span className={classnames("link-functional", { 'is-normal': localStorage.locales_url_format === 'normal' })}
                                onClick={() => this.getLink(req, true)}>
                                {req.displayName}
                            </span>}
                    </td>
                    <td data-label={this.props.translate("Search.Cee.DateRequested")}>
                        {req.insertedFormated}
                    </td>
                    <td data-label={this.props.translate("Search.Cee.Status")} style={{ fontWeight: req.status === "Read" ? "400" : "600" }} >
                        <Translate id={`Search.Cee.Status.${req.status}`} />
                    </td>
                    <td data-label={this.props.translate("Search.Cee.DateProcessed")}>
                        {req.completedFormated}
                    </td>
                    <td data-label={this.props.translate("SearchResult.ResultsCount")} >{req.count}</td>
                </tr>
                {req.children && req.children.map((child, i) => this.getRow(child, true, i))}
            </React.Fragment>
        )
    }

    getLink = (req, push = true) => {
        if (req.status !== STATUS.unprocessed && req.status !== STATUS.delayed && req.completed) {
            if (!push)
                return true;
            if (req.isOwnershipDeed)
                return this.props.history.push(`/search/property-cz/report-ownership-deed?id=${req.id}`);
            if (req.parentId)
                return this.props.history.push(`/search/property-cz/report-ownership-deed?telId=${req.telId}&ownershipDocumentId=${req.ownershipDeedNo}&osId=${req.osId}&cadastreUnitId=${req.cadastreUnitId}`);

            return this.props.history.push(`/search/property-cz/results/${req.id}?isEvidence=${req.isEvidence}&isOwnershipDeed=${req.isOwnershipDeed}`);
        }

        return false;
    }
}

export default withRouter(withLocalize(connect(
    null,
    dispatch => bindActionCreators(layoutActions, dispatch)
)(PropertyCzSearchRequests)));
